'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPortableWifiOff = function MdPortableWifiOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm5.5 4.1l1.6 1.8 27.9 27.9-2.1 2.1-12.5-12.6h-0.1l-0.3 0.1q-1.3 0-2.3-1.1t-1.1-2.3l0.1-0.3-2.6-2.7q-0.7 1.4-0.7 3 0 3.8 3.2 5.8l-1.6 2.9q-2.3-1.4-3.6-3.7t-1.4-5q0-3 1.6-5.4l-2.4-2.4q-2.6 3.6-2.6 7.8 0 3.6 1.8 6.7t4.9 4.9l-1.7 2.9q-3.8-2.2-6-6.1t-2.2-8.4q0-5.8 3.4-10.2l-3.4-3.5z m14.5 2.5q-3.4 0-6.2 1.6l-2.5-2.4q3.9-2.4 8.7-2.4 6.9 0 11.8 4.8t4.8 11.8q0 4.8-2.4 8.7l-2.5-2.4q1.7-3.1 1.7-6.3 0-5.5-4-9.4t-9.4-4z m9.3 17.2l-2.7-2.8q0-0.3 0-1 0-2.7-1.9-4.7t-4.7-1.9q-0.7 0-1 0l-2.7-2.7q1.7-0.7 3.7-0.7 4.1 0 7.1 2.9t2.9 7.1q0 2-0.7 3.8z' })
        )
    );
};

exports.default = MdPortableWifiOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/portable-wifi-off.js
// module id = 1084
// module chunks = 0